import { t } from "i18next";
import { twMerge } from "tailwind-merge";
import PropTypes from "prop-types";

const Button = (props) => {
  const {
    style = {},
    className = "",
    text = "",
    children,
    size = "medium",
    ...restProps
  } = props;

  const isSmall = size === "small";
  const sizeConfig = {
    small: "inline-block px-4 py-2",
    medium: "px-5 py-2.5",
    large: "h-12 px-5 py-2.5",
    default: "px-5 py-2.5",
  };
  const cls = twMerge(
    `uppercase text-sm buttonFontWeight select-none appearance-none border disabled:cursor-not-allowed rounded-md ${
      sizeConfig[size] || sizeConfig.default
    } `,
    className
  );

  return (
    <button
      style={{
        minWidth: isSmall ? undefined : "9rem",
        transition: "box-shadow 0.3s ease-in-out",
        ...style,
      }}
      className={cls}
      onMouseOver={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 6px -1px #CACACA";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "none";
      }}
      {...restProps}
    >
      {children || t(text)}
    </button>
  );
};
const ButtonPropTypes = {
  disabled: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseLeave: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  children: PropTypes.node,
};

Button.propTypes = ButtonPropTypes;

export { Button, ButtonPropTypes };
